import { ApiService } from "../../api";
import { Product } from "./Product";

export interface IProductPatch {
	name?: string;
	code?: string;
	active?: boolean;
	bundle_ids?: number[];
}

/**
 * Functions for working with products.
 */
export class ProductService {
	protected apiService: ApiService;

	constructor() {
		this.apiService = new ApiService();
	}

	/**
	 * Find all product products
	 */
	public async findAll(): Promise<Product[]> {
		const productData = await this.apiService.get("/api/v1/products");
		const products = await productData.json();

		return Product.fromJsonArray(products);
	}

	/**
	 * Saves only the fields given.
	 */
	public async patch(id: number, fields: IProductPatch): Promise<Product> {
		const response = await this.apiService.patch(
			`/api/v1/product/${id}`,
			fields,
		);
		return Product.fromJson(await ApiService.readJson(response));
	}

	/**
	 * Switches many products on or off at once. Returns the ids that changed.
	 */
	public async setActive(ids: number[], active: boolean): Promise<number[]> {
		const response = await this.apiService.post(
			"/api/v1/products/bulk-active",
			{ ids, active },
		);
		const result = await ApiService.readJson(response);
		return result.updated;
	}

	public async create(product: Product): Promise<Product> {
		const productData = await this.apiService.post(
			`/api/v1/products`,
			product,
		);
		const newProduct = await productData.json();
		return Product.fromJson(newProduct);
	}

	/**
	 * Find all products purchased by an account
	 */
	public async findByAccount(
		accountId: string,
		page: number = 1,
		perPage: number = 15,
	): Promise<any> {
		const params = new URLSearchParams({
			page: page.toString(),
			per_page: perPage.toString(),
		});
		const response = await this.apiService.get(
			`/api/v1/accounts/${accountId}/products?${params}`,
		);
		const data = await response.json();
		return data;
	}
}
